import { ReactNode } from "react";

interface UsageFeatureTeaserCardProps {
  title: string;
  description: string;
  preview: ReactNode;
  actionLabel: string;
  actionIcon?: ReactNode;
  disabled?: boolean;
  onAction: () => void;
}

function UsageFeatureTeaserCard({
  title,
  description,
  preview,
  actionLabel,
  actionIcon,
  disabled = false,
  onAction,
}: UsageFeatureTeaserCardProps) {
  return (
    <article className="flex h-full flex-col rounded-lg border border-gray-200 bg-white p-5">
      <div>
        <h2 className="font-heading text-lg font-semibold text-gray-700">
          {title}
        </h2>
        <p className="mt-1 text-sm text-gray-600">{description}</p>
      </div>

      {/* Grows to absorb any height difference between cards so the actions stay level. */}
      <div
        className="my-5 flex min-h-[7rem] flex-1 items-center rounded-md border border-gray-100 bg-gray-50 p-4"
        aria-hidden
      >
        {preview}
      </div>

      <button
        type="button"
        className="btn-primary btn-small mt-auto inline-flex items-center gap-2 self-start"
        disabled={disabled}
        onClick={onAction}
      >
        {actionIcon}
        {actionLabel}
      </button>
    </article>
  );
}

export default UsageFeatureTeaserCard;
